import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'
import { Link } from 'react-router-dom'
import { fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
import { PaginationWrapper } from 'shs-pagination'
import { createSelector } from '@reduxjs/toolkit'

const selectGroups = state => state.adminInputGroups
const selectGroupsPaginator = state => state.paginator.adminInputGroups

const makeGroups = createSelector(
    [selectGroups, selectGroupsPaginator],
    (groups, paginator) => {
        if (paginator) {
            return groups
                .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
                .sort((a, b) => {
                    if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                        return 1
                    }
                    return -1
                })
        }
        return []
    }
)

const mapStateToProps = (state, ownProps) => {
    const paginator = selectGroupsPaginator(state)
    const groups = makeGroups(state)
    return {
        paginator,
        groups
    }
}

const AdminTemplateGroupList = ({ dispatch, navigate, params, paginator, groups }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/input-groups', 'LIST'), { perpage: 25 }))
    }, [dispatch])

    const renderGroupRow = (group, index) => {
        return (
            <tr key={group.id}>
                <td className="index">{index}</td>
                <td className="main">{group.name}</td>
                <td className="main">
                    <Link className="btn small outline" to={buildRoutePath(routes.adminTemplateGroupView.path, { groupId: group.id })}>
                        Edit
                    </Link>
                </td>
            </tr>
        )
    }

    const handlePaginationUpdate = (paginationParams) => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/input-groups', 'LIST'), paginationParams))
    }

    const renderGroups = () => {
        if (!paginator) {
            return null
        }
        let allGroups = []
        groups?.forEach((group, idx) => {
            let index = idx + ((paginator.currentPage - 1) * paginator.perPage) + 1
            allGroups.push(renderGroupRow(group, index))
        })
        return (
            <PaginationWrapper
                paginator={paginator}
                controls={{ search: { enabled: true, collapsed: false } }}
                callbackFX={handlePaginationUpdate}
                renderItems={allGroups}
            >
                <table className="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Group Name</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allGroups}
                    </tbody>
                </table>
            </PaginationWrapper>
        )
    }

    if (!groups) {
        return <div>Loading...</div>
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Question Groups</h1>
                    </div>
                    <div className="header-actions">
                        <Link className="btn blue" to={buildRoutePath(routes.adminTemplateGroupCreate.path)}>
                            Create New Group
                        </Link>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    {renderGroups()}
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminTemplateGroupList))
